import SmartTooltip from "../Info/SmartTooltip";
import Button from "../Buttons/Button";
import { showToast } from "../Toast/Toast";

const CopyToClipboard = ({
  description = "copy",
  tooltipPosition = "bottom",
  content,
  title,
  color = "dark", // primary, secondary, success, danger, warning, info, dark
  size = "xs-sm", // xs-sm, xs, sm, md, lg, xl
  onCopy,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      showToast(`${title} Copied To Clipboard!`, "success", 2000);
      if (onCopy) onCopy();
    } catch (err) {
      console.error("Failed to copy: ", err);
      showToast("Failed To Copy!", "error", 2000);
    }
  };
  return (
    <SmartTooltip
      noicon
      description={description}
      tooltipPosition={tooltipPosition}
      variant="outlined"
    >
      <Button
        type={"icon"}
        variant="text"
        color={color}
        icon={"content_copy"}
        className="!justify-start py-1"
        size="xs-sm"
        onClick={() => handleCopy()}
      />
    </SmartTooltip>
  );
};

export default CopyToClipboard;
